import { Dispatch, SetStateAction } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button } from "@mui/material";
import { isEnglishString } from "../utils/validations";

interface AddCategoryModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  handleSubmit: () => void;
  setCategoryName: Dispatch<SetStateAction<string>>;
  categoryName: string;
  error: boolean;
  selectedId: string;
}

export default function AddCategory({
  open,
  onClose,
  setOpen,
  handleSubmit,
  categoryName,
  setCategoryName,
  selectedId,
  error,
}: AddCategoryModalProps) {
  return (
    <Modal className="modal addCategory_modal" open={open} onClose={onClose}>
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>{selectedId ? "Update" : "Add"} Category</h2>
            <div className="btn-close" onClick={onClose}>
              <CloseIcon />
            </div>
          </div>
          <form className="form" action="">
            <div className="control_group">
              <label>Category Name</label>
              <TextField
                placeholder="Enter Category Name"
                fullWidth
                hiddenLabel
                value={categoryName}
                onChange={(val) => {
                  if (isEnglishString(val.target.value)) {
                    setCategoryName(val.target.value);
                  }
                }}
              />
              {!categoryName && error ? (
                <h6 className="err_msg">This field is required</h6>
              ) : (
                ""
              )}
            </div>
            <div className="footer_btn_flex">
              <Button className="btn btn_grey" onClick={onClose}>
                Cancel
              </Button>
              <Button className="btn btn_primary" onClick={handleSubmit}>
                Submit
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
